import { Info24px } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

import I18n, { useTranslation } from "pro-features/components/WithTranslation/src/I18n";
import { AssetsService } from "app/services/AssetsService";

import {
    StyledScreenWrapper,
    StyledScreenTitle,
    StyledScreenDescription,
    StyledIllustration,
    ImportantContainer,
} from "../../styles";
import type { IStepScreenProps } from "../../types";

const { carbon } = colorsPalettes;

export const NewSolutionSuccessScreen = ({ config }: IStepScreenProps) => {
    const translate = useTranslation();
    return (
        <StyledScreenWrapper>
            <StyledScreenTitle
                fontVariant="h3"
                color={carbon[500]}
            >
                {translate(config.title)}
            </StyledScreenTitle>
            <StyledScreenDescription
                fontVariant="h6"
                color={carbon[400]}
            >
                {translate(config.subTitle)}
            </StyledScreenDescription>
            {config.importantText ? (
                <ImportantContainer>
                    <Tooltip content={translate("switch.solution.new.step.important.text.tooltip")}>
                        <Info24px
                            color={colorsPalettes.yellow[600]}
                            size="sm"
                        />
                    </Tooltip>
                    <Text
                        fontVariant="body2"
                        color={carbon[400]}
                    >
                        <I18n dangerouslySetInnerHTML>{translate(config.importantText)}</I18n>
                    </Text>
                </ImportantContainer>
            ) : null}
            <StyledIllustration>
                <img src={AssetsService.assetUrl("/images/swicons/illustration-churn.svg")} />
            </StyledIllustration>
        </StyledScreenWrapper>
    );
};
